<template>
	<div class="p-mb-3">
		<div>
			<p>
				<!--<b>{{ question }}</b>-->
				<b v-if="questionMark">
					<QuestionComments :questionMark="questionMark" :question="question" />
				</b>
				<b v-else> {{ question }} </b>
			</p>
			<HelpTooltip v-if="bookmark != undefined" :helpbookmark="bookmark" />
		</div>
		<!-- Listen to on change event instead of v-on:input to achieve same result as v-model.lazy -->
		<!-- <input
        v-bind:value="value"
        v-on:change="$emit('input', $event.target.value)"
      > -->
		<InputNumber
			:value="localValue"
			:disabled="disabled"
			@input="localValue = $event"
			@blur="$emit('input', localValue)"
			:useGrouping="false"
			:placeholder="placeholder"
		/>
	</div>
</template>

<script>
import InputNumber from "primevue/inputnumber";
import HelpTooltip from "../components/HelpTooltip";
import QuestionComments from "./QuestionComments.vue";
export default {
	name: "InputTextNumber",
	props: {
		question: String,
		value: [Number, String],
		placeholder: String,
		bookmark: String,
		disabled: {
					type: Boolean,
					default: false
				},
		questionMark: String
	},
	components: {
		InputNumber,
		HelpTooltip,
		QuestionComments
	},
	data() {
		return {
			localValue: this.value
		};
	},
	watch: {
		value(newVal) {
			this.localValue = newVal;
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
